"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCheckbox = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M51 52a.5.5 0 0 1-.5.5H18.63a.5.5 0 0 1-.5-.5V20a.5.5 0 0 1 .5-.5h29.21l3.63-3.63a4.22 4.22 0 0 0-.93-.11H18.63A4.25 4.25 0 0 0 14.39 20v32a4.24 4.24 0 0 0 4.24 4.24h31.91A4.24 4.24 0 0 0 54.78 52V28.47L51 32.2z"
  }), _react["default"].createElement("path", {
    d: "M63.12 14.84a1.87 1.87 0 1 0-2.64-2.64L34.76 37.91 26.81 30a1.87 1.87 0 0 0-2.64 2.64L34.76 43.2z"
  })),
  height: undefined,
  width: undefined
});
IconCheckbox.displayName = 'IconCheckbox';
var _default = IconCheckbox;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/checkbox.js
// module id = 562
// module chunks = 0